import { ReactNode } from 'react'
import type { PostHogConfig } from 'posthog-js'
import { PostHogProvider } from '@posthog/react'

import { env } from 'portal/lib/config/env-config'

export const postHogOptions: Partial<PostHogConfig> = {
  api_host: env.POSTHOG_HOST,
  ui_host: 'https://eu.posthog.com', // necessary because you're using a proxy, this way links will point back to PostHog properly
  // We identify() the signed-in user (see PostHogIdentify), so only identified
  // users get person profiles; anonymous pre-login activity does not.
  // (but this still creates anon users and hooks them up
  // with real userIDs once they log in I think)
  person_profiles: 'identified_only',
  // Turn off PostHog stuff we're not using that defaults to ON
  autocapture: false,
  capture_pageview: false,
  capture_exceptions: false,
  capture_performance: false,
  capture_heatmaps: false,
  capture_dead_clicks: false,
  disable_surveys: true,
  disable_conversations: true,
  disable_session_recording: true,
  disable_product_tours: true
}

/**
 * Wires up the PostHog client for the portal — the only thing we currently use
 * PostHog for is feature flags (see useFeatureGate).
 */
export function PostHogAppProvider({ children }: { children?: ReactNode }) {
  return (
    <PostHogProvider
      apiKey={env.POSTHOG_PROJECT_TOKEN}
      options={postHogOptions}
    >
      {children}
    </PostHogProvider>
  )
}
